import { render, staticRenderFns } from "./CustomAutocomplete.vue?vue&type=template&id=05a78eb7&scoped=true&"
import script from "./CustomAutocomplete.vue?vue&type=script&lang=js&"
export * from "./CustomAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a78eb7",
  null
  
)

export default component.exports